module.exports = __webpack_public_path__ + "img/dd.83861342.jpg";